import { createSelector } from 'reselect';

const fanSelector = ({ fan = {} }) => fan;

export default createSelector(fanSelector, (fan) => fan);

export const favoriteTeamSelector = createSelector(
    fanSelector,
    ({ preferences }) => {
        let uids;
        if (!preferences || !preferences.metaData) {
            return uids;
        }

        uids = preferences
            .filter(({ metaData }) => !!metaData.team)
            .map(({ metaData }) => {
                const { sportId, teamId } = metaData;
                let value = '';
                // do not grab `uid` since it includes the league info we never supports
                if (sportId) {
                    value = `s:${sportId}`;
                    if (teamId) {
                        value += `~t:${teamId}`;
                    }
                }
                return value;
            });
        return uids.join(',');
    }
);

export const favoriteSportSelector = createSelector(
    fanSelector,
    ({ preferences }) => {
        let uids;
        if (!preferences || !preferences.metaData) {
            return uids;
        }

        uids = preferences
            .filter(({ metaData }) => !!metaData.sport)
            .map(({ metaData }) => {
                const { sportId } = metaData;
                let value = '';
                // do not grab `uid` since it includes the league info we never supports
                if (sportId) {
                    value = `s:${sportId}`;
                }
                return value;
            });
        return uids.join(',');
    }
);



// WEBPACK FOOTER //
// ./app/common/selectors/fanSelector.js